







import { Component, Vue } from 'vue-property-decorator';

const SingleItemProps = Vue.extend({
  props: {
    model: {
      type: Object,
      default: () => {
        return null;
      }
    },
    list: {
      type: Array,
      default: () => {
        return [];
      }
    },
    listKey: {
      type: String,
      default: 'items'
    }
  }
});

@Component
export default class SingleItem extends SingleItemProps {
  printTitle({name, translationKey}) {
    const key = `route.${translationKey || name}`;
    return this.$te(key) ? this.$t(key) : name;
  }
}
